"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _base = _interopRequireDefault(require("@emotion/styled/base"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _css2 = _interopRequireDefault(require("@styled-system/css"));

var _md = require("react-icons/md");

var _styledSystem = require("styled-system");

var _FormCheckGroupContext = require("../FormCheckGroupContext/FormCheckGroupContext");

var _system = _interopRequireWildcard(require("../../../utils/system"));

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var propTypes = {
  disabled: _propTypes.bool,
  label: _propTypes.node.isRequired,
  isValid: _propTypes.bool,
  value: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number]),
  variantColor: _propTypes.string,
  size: (0, _propTypes.oneOf)(['sm', 'md', 'lg']),
  classes: (0, _propTypes.shape)({
    root: (0, _propTypes.oneOfType)([(0, _propTypes.shape)({}), _propTypes.func]),
    field: (0, _propTypes.oneOfType)([(0, _propTypes.shape)({}), _propTypes.func]),
    checkbox: (0, _propTypes.oneOfType)([(0, _propTypes.shape)({}), _propTypes.func]),
    icon: (0, _propTypes.oneOfType)([(0, _propTypes.shape)({}), _propTypes.func])
  })
};
var defaultProps = {
  disabled: false,
  isValid: true,
  variantColor: 'primary.main',
  size: 'md',
  value: '',
  classes: {
    root: null,
    field: null,
    checkbox: null,
    icon: null
  }
};
var Label = (0, _system["default"])('label')({
  label: 'Label'
}, function (_ref) {
  var isValid = _ref.isValid;
  return (0, _css2["default"])({
    cursor: 'pointer',
    alignItems: 'center',
    boxSizing: 'border-box',
    color: !isValid ? 'danger' : 'text',
    display: 'flex',
    fontFamily: 'body',
    fontWeight: 'normal'
  });
}, function (_ref2) {
  var disabled = _ref2.disabled;
  return disabled && {
    opacity: 0.6
  };
}, (0, _styledSystem.variant)({
  prop: 'cSize',
  scale: 'checkbox',
  variants: {
    sm: {
      fontSize: 'xs'
    },
    md: {
      fontSize: 'sm'
    },
    lg: {
      fontSize: 'md'
    }
  }
}), (0, _system.classesStyles)('root'));
var Field = (0, _base["default"])("input", process.env.NODE_ENV === "production" ? {
  target: "ed90lku2"
} : {
  target: "ed90lku2",
  label: "Field"
})("display:none;", (0, _system.classesStyles)('field'));
var Icon = ( /*#__PURE__*/0, _base["default"])(_md.MdDone, process.env.NODE_ENV === "production" ? {
  target: "ed90lku1"
} : {
  target: "ed90lku1",
  label: "Icon"
})((0, _css2["default"])({
  opacity: 0,
  color: 'white',
  transition: 'transform .3s ease-out 0s, opacity .3s ease-out 0s',
  transform: 'scale(0.90)'
}), (0, _system.classesStyles)('icon'));
var Checkbox = (0, _base["default"])("span", process.env.NODE_ENV === "production" ? {
  target: "ed90lku0"
} : {
  target: "ed90lku0",
  label: "Checkbox"
})(function (_ref3) {
  var variantColor = _ref3.variantColor;
  return (0, _css2["default"])(_defineProperty({
    mr: 2,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 'md',
    border: '1px solid',
    borderColor: 'gray.400',
    boxSizing: 'border-box',
    bg: 'white',
    flexShrink: 0,
    transition: 'background-color .3s ease-out 0s'
  }, "".concat(Field, ":checked ~ &"), {
    bg: variantColor,
    borderColor: variantColor,
    svg: {
      transform: 'scale(1)',
      opacity: 1
    }
  }));
}, (0, _styledSystem.variant)({
  prop: 'cSize',
  scale: 'checkbox',
  variants: {
    sm: {
      size: 4
    },
    md: {
      size: 5
    },
    lg: {
      size: 6
    }
  }
}), (0, _system.classesStyles)('checkbox'));
var Component = /*#__PURE__*/(0, _react.forwardRef)(function (_ref4, ref) {
  var classes = _ref4.classes,
      disabled = _ref4.disabled,
      label = _ref4.label,
      isValid = _ref4.isValid,
      size = _ref4.size,
      variantColor = _ref4.variantColor,
      props = _objectWithoutProperties(_ref4, ["classes", "disabled", "label", "isValid", "size", "variantColor"]);

  var _useFormCheckGroup = (0, _FormCheckGroupContext.useFormCheckGroup)(),
      _useFormCheckGroup$va = _useFormCheckGroup.variantColor,
      contextVariantColor = _useFormCheckGroup$va === void 0 ? variantColor : _useFormCheckGroup$va,
      _useFormCheckGroup$di = _useFormCheckGroup.disabled,
      contextDisabled = _useFormCheckGroup$di === void 0 ? disabled : _useFormCheckGroup$di,
      _useFormCheckGroup$is = _useFormCheckGroup.isValid,
      contextIsValid = _useFormCheckGroup$is === void 0 ? isValid : _useFormCheckGroup$is,
      _useFormCheckGroup$si = _useFormCheckGroup.size,
      contextSize = _useFormCheckGroup$si === void 0 ? size : _useFormCheckGroup$si,
      contextValue = _useFormCheckGroup.value,
      context = _objectWithoutProperties(_useFormCheckGroup, ["variantColor", "disabled", "isValid", "size", "value"]);

  var checked = contextValue && Array.isArray(contextValue) ? contextValue.includes(props.value) : undefined;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(Label, {
    isValid: contextIsValid,
    disabled: contextDisabled,
    classes: classes,
    cSize: contextSize,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(Field, _objectSpread(_objectSpread({
      ref: ref,
      disabled: contextDisabled,
      classes: classes,
      checked: checked,
      type: "checkbox"
    }, props), context)), /*#__PURE__*/(0, _jsxRuntime.jsx)(Checkbox, {
      cSize: contextSize,
      variantColor: contextVariantColor,
      classes: classes,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(Icon, {
        classes: classes
      })
    }), label]
  });
});
Component.displayName = 'FormCheck';
Component.propTypes = propTypes;
Component.defaultProps = defaultProps;
var _default = Component;
exports["default"] = _default;

//# sourceMappingURL=FormCheck.js.map